import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'fs-webhook-remove-modal',
  templateUrl: './webhook-remove-modal.component.html',
})
export class WebhookRemoveModalComponent {
  @Input() isActive = false;
  @Output() isActiveChange = new EventEmitter();
  @Output() submitChange = new EventEmitter();

  hideModal(): void {
    this.isActiveChange.emit(false);
  }

  onSubmit(): void {
    this.submitChange.emit(true);
    this.hideModal();
  }
}
